import { Wifi, WifiOff, Clock, HelpCircle } from "lucide-react";
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";

const MAP = {
  online: { color: "#10B981", icon: Wifi, label: "Online", tip: "Heartbeat within the last 20 minutes" },
  delayed: { color: "#F59E0B", icon: Clock, label: "Delayed", tip: "Last heartbeat 20–35 minutes ago" },
  offline: { color: "#EF4444", icon: WifiOff, label: "Offline", tip: "No heartbeat for over 35 minutes" },
  awaiting: { color: "#6B7280", icon: HelpCircle, label: "Awaiting", tip: "No heartbeat received yet (Online ≤20 min · Delayed ≤35 min · Offline >35 min)" },
  unknown: { color: "#6B7280", icon: HelpCircle, label: "Unknown", tip: "No heartbeat data received yet" },
};

export function StatusPill({ status, testid }) {
  const cfg = MAP[status] || MAP.awaiting;
  const Icon = cfg.icon;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={testid}
            className="inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-medium"
            style={{ color: cfg.color, borderColor: cfg.color + "40", backgroundColor: cfg.color + "1a" }}
          >
            <Icon className="h-3 w-3" />
            {cfg.label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="bg-[#141414] border-[#262626] text-foreground">{cfg.tip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

const TXN = {
  success: { c: "#10B981", l: "Success" },
  refunded: { c: "#F59E0B", l: "Refunded" },
  failed: { c: "#EF4444", l: "Failed" },
  pending: { c: "#6B7280", l: "Pending" },
};

export function TxnBadge({ status, testid }) {
  const cfg = TXN[status] || TXN.pending;
  return (
    <span data-testid={testid} className="inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium mono"
      style={{ color: cfg.c, borderColor: cfg.c + "40", backgroundColor: cfg.c + "1a" }}>
      {cfg.l}
    </span>
  );
}
